import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Acchajee Travels";
const BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function Seo({
  title,
  description,
  path = "/",
  image,
  type = "website",
  schema,
  noindex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Holiday Packages, Visa Assistance & Honeymoon Tours from India`;
  const desc = description || "Acchajee Travels — India's trusted travel agency for domestic & international holiday packages, visa assistance, cruises, honeymoon and corporate travel. Best prices, 24x7 support, IATA approved.";
  const url = `${BASE}${path}`;
  const img = image || `${BASE}/og-image.jpg`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
}
